import { render, staticRenderFns } from "./ChatSpinner.vue?vue&type=template&id=4278c31c&scoped=true"
import script from "./ChatSpinner.vue?vue&type=script&lang=js"
export * from "./ChatSpinner.vue?vue&type=script&lang=js"
import style0 from "./ChatSpinner.vue?vue&type=style&index=0&id=4278c31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278c31c",
  null
  
)

export default component.exports